module.exports = __webpack_public_path__ + "static/img/invest.7f85a29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/invest.png
// module id = QD/Y
// module chunks = 1